const from2 = require('from2')
const toBuffer = require('typedarray-to-buffer')

export function filereader(file, options) {
	options = options || {}
	let offset = options.offset || 0
	let chunkSize = options.chunkSize || 1024 * 1024 // default 1MB chunk has tolerable perf on large files
	let fileReader = new FileReader(file)

	let from = from2(function (size, cb) {
		if (offset >= file.size) return cb(null, null)
		fileReader.onloadend = function loaded(event) {
			var data = event.target.result
			if (data instanceof ArrayBuffer) data = toBuffer(new Uint8Array(event.target.result))
			cb(null, data)
		}
		let end = offset + chunkSize
		let slice = file.slice(offset, end)
		fileReader.readAsText(slice, options.encoding || 'utf8')
		offset = end
	})

	from.name = file.name
	from.size = file.size
	from.type = file.type
	from.lastModified = file.lastModified

	fileReader.onerror = function (err) {
		from.destroy(err)
	}

	return from
}
